import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_45: FaireProductEntity = {
  token: "legacy_prod_abbott-45",
  type: "product",
  name: 'Medium Flower Bloom Bowl Green 5" D',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/117da23ee6ba996eae003f5eaffbb95bde7de48ce807caab1531ce0c98c999da.jpeg",
  priceDollars: 24,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
